import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const inputStyles: SxStyles = {
  inputContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    mb: getResponsiveSize(15),
    '& .MuiTypography-root': {
      fontFamily: theme.typography.mainFontFamily,
      fontSize: getResponsiveSize(14.5),
      fontWeight: '400',
    },
    '& .audio-switch': {
      alignSelf: 'flex-end',
    },
    '& .MuiInputBase-root': {
      borderRadius: theme.palette.propVars?.borderRadius,
      width: getResponsiveSize(317),
    },

    '& .MuiFormLabel-root': {
      display: 'flex',
      fontSize: getResponsiveSize(11.5),
      fontFamily: theme.typography.mainFontFamily,
      alignSelf: 'center',
    },

    '& .MuiOutlinedInput-root': {
      padding: 0,

      '& .MuiInputBase-input': {
        padding: getResponsiveSize(8.5),
      },
    },

    [theme.breakpoints.media?.laptop!]: {
      '& .MuiTypography-root': {
        fontSize: getResponsiveSize(13),
      },
    },
  },
};
